export const Citation = ({ numbers, testId }) => <sup data-testid={`${testId}-citations`}>
  {numbers.map((number) => <a key={number} href={`#reference-${number}`} data-testid={`${testId}-citation-link-${number}`}>[{number}]</a>)}
</sup>;

export const renderTextWithCitations = (text, testId) => text.split(/(https?:\/\/[^\s)]+|\*\*[^*]+\*\*|\*[^*]+\*|\[\s*\d+\s*\])/g).map((part, index) => {
  if (/^https?:\/\//.test(part)) return <a className="article-external-link" key={`${testId}-external-${index}`} href={part} target="_blank" rel="noreferrer" data-testid={`${testId}-external-link-${index}`}>{part}</a>;
  const emphasis = part.match(/^\*\*(.+)\*\*$/);
  if (emphasis) return <strong key={`${testId}-emphasis-${index}`}>{emphasis[1]}</strong>;
  const italic = part.match(/^\*([^*]+)\*$/);
  if (italic) return <em key={`${testId}-italic-${index}`}>{italic[1]}</em>;
  const match = part.match(/^\[\s*(\d+)\s*\]$/);
  if (!match) return part;
  return <sup key={`${testId}-inline-citation-${index}`} data-testid={`${testId}-inline-citation-${match[1]}-${index}`}>
    <a href={`#reference-${match[1]}`} data-testid={`${testId}-inline-citation-link-${match[1]}-${index}`}>{part}</a>
  </sup>;
});